import { render, staticRenderFns } from "./StoreList.vue?vue&type=template&id=2b36bcf8&scoped=true"
import script from "./StoreList.vue?vue&type=script&lang=js"
export * from "./StoreList.vue?vue&type=script&lang=js"
import style0 from "./StoreList.vue?vue&type=style&index=0&id=2b36bcf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b36bcf8",
  null
  
)

export default component.exports